import { FieldArray, FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import moment from "moment";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import ATMRadioButton from "src/components/UI/atoms/ATMRadioButton/ATMRadioButton";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import { AiOutlinePlus } from "react-icons/ai";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import { MdDelete } from "react-icons/md";
import { useLocation } from "react-router-dom";
import AccordianFormLayout from "src/components/layouts/AccordianFormLayout/AccordianFormLayout";
import { handleValidNumber } from "src/utils/validations/numberInput";
import useCountries from "src/hooks/useCountries";
import useCountryStates from "src/hooks/useCountryStates";
import useStateCities from "src/hooks/useStateCities";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import useBranches from "src/hooks/useGetBranches";

type Props = {
  formikProps: FormikProps<any>;
  onRedirect: () => void;
  setStudentNumber: any;
};

const GenderOption = [
  {
    label: "Female",
    value: "FEMALE",
  },
  {
    label: "Male",
    value: "MALE",
  },
  {
    label: "Other",
    value: "OTHER",
  },
];
const CourseOption = [
  {
    label: "Tech",
    value: "TECH",
  },
  {
    label: "Non-Tech",
    value: "NON_TECH",
  },
];
const MaritalStatusOption = [
  {
    label: "Single",
    value: "SINGLE",
  },
  {
    label: "Married",
    value: "MARRIED",
  },
  {
    label: "Separate",
    value: "SEPARATE",
  },
];

const CollegeTearOption = [
  {
    label: "Tier One",
    value: "TIER_ONE",
  },
  {
    label: "Tier Two",
    value: "TIER_TWO",
  },
  {
    label: "Tier Three",
    value: "TIER_THREE",
  },
];

const StudentForm = ({ formikProps, onRedirect, setStudentNumber }: Props) => {
  const location = useLocation();
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  //   Get All Branched
  const { branches, isDataLoading: isBranchLoading } = useBranches();
  //   Get All Countries
  const { countries, isDataLoading: isCountriesLoading } = useCountries();
  //   Get All States
  const { countryStates, isDataLoading: isCountryStatesLoading } =
    useCountryStates(values?.countryId?.value || "");
  //   Get All City
  const { stateCities, isDataLoading: isStateCitiesLoading } = useStateCities(
    values?.stateId?.value || ""
  );
  const currentPath = `/${location.pathname?.split("/")[2]}`;

  const generatePassword = (name: any) => {
    var randomChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$";
    var password = name.slice(0, 3); // Take the first three letters of the name

    // Append two random characters
    for (var i = 0; i < 5; i++) {
      var randomIndex = Math.floor(Math.random() * randomChars.length);
      password += randomChars.charAt(randomIndex);
    }

    return setFieldValue("password", password);
  };

  return (
    <div className="p-4 gap-6">
      <div className="flex flex-col gap-6 font-semibold text-lg mb-4">
        {currentPath === "/edit" ? "Edit" : "Add"} Form
      </div>
      <div className="border-l-[3px] border-primary-dark px-3 py-1 mb-2 font font-medium text-[18px]  bg-white  text-primary-dark">
        Personal Information
      </div>
      <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 pl-2">
        {/* Mobile */}
        <div>
          <ATMTextField
            required
            name="mobile"
            value={values.mobile}
            onChange={(e) => {
              handleValidNumber(e, { forMobile: true }) &&
                setFieldValue("mobile", e.target.value);
              handleValidNumber(e, { forMobile: true }) &&
                setStudentNumber(e.target.value);
            }}
            label="Mobile"
            onBlur={handleBlur}
            placeholder="Enter Mobile number"
          />
        </div>
        {/* Student Name */}
        <div>
          <ATMTextField
            required
            name="name"
            value={values.name}
            onChange={(e) => {
              setFieldValue("name", e.target.value);
            }}
            label="Student Name"
            placeholder="Enter Student Name"
            onBlur={handleBlur}
          />
        </div>
        {/* UserName */}
        {currentPath !== "/edit" && (
          <div>
            <ATMTextField
              required
              name="username"
              value={values?.username}
              onChange={(e) => {
                setFieldValue("username", e.target.value);
              }}
              label="Student UserName"
              placeholder="Enter Student UserName"
              onBlur={handleBlur}
            />
          </div>
        )}

        {/*Whatsapp Number */}
        <div>
          <ATMTextField
            name="whatsApp_mobile"
            value={values.whatsApp_mobile}
            onChange={(e) => {
              handleValidNumber(e, { forMobile: true }) &&
                setFieldValue("whatsApp_mobile", e.target.value);
            }}
            label="Whatsapp Number"
            placeholder="Enter Whatsapp number"
            onBlur={handleBlur}
          />
        </div>
        {/* Emergency Contact Details */}
        <div>
          <ATMTextField
            name="emergency_contact_no"
            value={values.emergency_contact_no}
            onChange={(e) => {
              handleValidNumber(e, { forMobile: true }) &&
                setFieldValue("emergency_contact_no", e.target.value);
            }}
            label="Emergency Contact number"
            placeholder="Enter Emergency number"
            onBlur={handleBlur}
          />
        </div>
        {/* DOB */}
        <div>
          <ATMDatePicker
            name="dob"
            views={["day", "month", "year"]}
            value={values.dob || null}
            onChange={(newValue) => setFieldValue("dob", newValue)}
            label="DOB"
            maxDate={moment().format("yyyy-MM-DD")}
          />
        </div>
        {/* Email */}
        <div>
          <ATMTextField
            required
            name="email"
            value={values.email}
            onChange={(e) => {
              setFieldValue("email", e.target.value);
            }}
            label="Email"
            placeholder="Enter Email "
            onBlur={handleBlur}
          />
        </div>

        {/*  Blood Group */}
        <div>
          <ATMTextField
            name="blood_group"
            value={values.blood_group}
            onChange={(e) => {
              setFieldValue("blood_group", e.target.value);
            }}
            label=" Blood Group "
            onBlur={handleBlur}
            placeholder="Enter Blood group "
          />
        </div>
        {currentPath !== "/edit" && (
          <div className=" relative ">
            <ATMTextField
              name="password"
              required
              value={values?.password}
              onChange={(e) => {
                setFieldValue("password", e.target.value);
              }}
              label="Password"
              placeholder="Enter Password"
              onBlur={handleBlur}
            />
            <div className="absolute top-7 right-2">
              <button
                disabled={!values?.name}
                className="bg-primary-dark p-1 text-white font-semibold rounded-md text-[15px]"
                type="button"
                onClick={() => {
                  generatePassword(values?.name);
                }}
              >
                Generate
              </button>
            </div>
          </div>
        )}

        {/* Gender */}
        <div>
          <ATMRadioButton
            label="Gender"
            name="gender"
            value={values?.gender || ""}
            className="mt-1  flex"
            options={GenderOption}
            onChange={(e) => {
              setFieldValue("gender", e);
            }}
          />
        </div>

        {/* Country */}
        <div className="">
          <ATMSelect
            name="countryId"
            value={values.countryId}
            onChange={(newValue) => {
              setFieldValue("countryId", newValue);
              setFieldValue("stateId", "");
              setFieldValue("cityId", "");
            }}
            label="Country"
            placeholder="Select Country"
            options={countries?.map((el: any) => {
              return {
                label: el?.countryName,
                value: el?._id,
              };
            })}
            isLoading={isCountriesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.label} </div>;
              } else {
                return <div className="capitalize"> {option?.label} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?.value === selected.value;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.label?.includes(searchValue)
                : true;
            }}
          />
        </div>

        {/* State */}
        <div className="">
          <ATMSelect
            name="stateId"
            value={values.stateId}
            onChange={(newValue) => {
              setFieldValue("stateId", newValue);
              setFieldValue("cityId", "");
            }}
            label="State"
            placeholder="Select State"
            options={countryStates?.map((el: any) => {
              return {
                label: el?.stateName,
                value: el?._id,
              };
            })}
            isLoading={isCountryStatesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.label} </div>;
              } else {
                return <div className="capitalize"> {option?.label} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?.value === selected.value;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.label?.includes(searchValue)
                : true;
            }}
            disabled={!values?.countryId}
          />
        </div>

        {/* City */}
        <div className="">
          <ATMSelect
            name="cityId"
            value={values.cityId}
            onChange={(newValue) => {
              setFieldValue("cityId", newValue);
            }}
            label="City"
            placeholder="Select City"
            options={stateCities?.map((el: any) => {
              return {
                label: el?.cityName,
                value: el?._id,
              };
            })}
            isLoading={isStateCitiesLoading}
            renderOption={(option, { context }) => {
              if (context === "menu") {
                return <div className="capitalize"> {option?.label} </div>;
              } else {
                return <div className="capitalize"> {option?.label} </div>;
              }
            }}
            isOptionEqualToValue={(option, selected) => {
              return option?.value === selected.value;
            }}
            isSearchedOption={(option, searchValue) => {
              return searchValue
                ? option?.data?.label?.includes(searchValue)
                : true;
            }}
            disabled={!values?.stateId}
          />
        </div>
        {/* Marital */}
        <div>
          <ATMRadioButton
            label="Marital Status"
            name="marital_status"
            value={values?.marital_status || ""}
            className="mt-1 flex"
            options={MaritalStatusOption}
            onChange={(e) => {
              setFieldValue("marital_status", e);
            }}
          />
        </div>
        {/* Branch Name */}
        <div>
          <ATMMultiSelect
            name="branchId"
            value={values.branchId}
            label="Branch"
            placeholder="Select branch"
            isLoading={isBranchLoading}
            options={branches?.map((branch: any) => ({
              label: branch?.branchName,
              value: branch?._id,
            }))}
            onChange={(newValue) => setFieldValue("branchId", newValue)}
            onBlur={handleBlur}
          />
        </div>
        {/* address */}
        <div>
          <ATMTextArea
            name="address"
            value={values.address}
            onChange={(value) => {
              setFieldValue("address", value);
            }}
            label="Address "
            onBlur={handleBlur}
            placeholder="Enter address "
          />
        </div>
      </div>
      <div className="mt-5 xl:px-2 px-0">
        <AccordianFormLayout formHeading="OTHER" isOpen={true}>
          <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4 p-2">
            {/* Linkedin ID */}
            <div className="">
              <ATMTextField
                name="linkedin_id"
                value={values?.linkedin_id}
                onChange={(e) => setFieldValue("linkedin_id", e.target.value)}
                label="Linkedin ID"
                placeholder="Enter Linkedin ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Twitter ID */}
            <div className="">
              <ATMTextField
                name="twitter_id"
                value={values?.twitter_id}
                onChange={(e) => setFieldValue("twitter_id", e.target.value)}
                label="Twitter ID"
                placeholder="Enter Twitter ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Instagram ID */}
            <div>
              <ATMTextField
                name="instagram_id"
                value={values.instagram_id}
                onChange={(e) => setFieldValue("instagram_id", e.target.value)}
                label="Instagram ID"
                placeholder="Enter Instagram ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Facebook ID */}
            <div className="">
              <ATMTextField
                name="facebook_id"
                value={values.facebook_id}
                onChange={(e) => setFieldValue("facebook_id", e.target.value)}
                label="Facebook ID"
                placeholder="Enter Facebook ID"
                onBlur={handleBlur}
              />
            </div>
            {/* Youtube ID */}
            <div className="">
              <ATMTextField
                name="youtube_id"
                value={values.youtube_id}
                onChange={(e) => setFieldValue("youtube_id", e.target.value)}
                label="Youtube ID"
                placeholder="Enter Youtube ID"
                onBlur={handleBlur}
              />
            </div>
          </div>
        </AccordianFormLayout>
      </div>
      <div className="my-4">
        <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px]  bg-white  text-primary-dark">
          Academic History
        </div>
        <div className="mt-1">
          <FieldArray
            name="academic_history"
            render={({ push, remove }) => (
              <>
                {values?.academic_history?.map((doc: any, index: any) => {
                  return (
                    <div key={index}>
                      <div className="flex justify-end mt-3">
                        <MdDelete
                          color="#F70913"
                          size={30}
                          className="pl-1 cursor-pointer"
                          onClick={() => {
                            showConfirmationDialog({
                              title: "Heads Up",
                              text: "Are you sure want to Delete this Academic History?",
                              icon: "question",
                              showCancelButton: true,
                              next: (result) => {
                                if (result.isConfirmed) {
                                  remove(index);
                                }
                              },
                            });
                          }}
                        />
                      </div>
                      <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4 items-center">
                        <div>
                          <div>
                            <ATMTextField
                              name={`academic_history[${index}].collge_school_name`}
                              value={
                                values?.academic_history?.[index]
                                  ?.collge_school_name
                              }
                              onChange={(e) =>
                                setFieldValue(
                                  `academic_history[${index}].collge_school_name`,
                                  e.target.value
                                )
                              }
                              label="College School Name"
                              placeholder="Enter College School Name"
                              onBlur={handleBlur}
                            />
                          </div>
                        </div>
                        <div>
                          <ATMTextField
                            name={`academic_history[${index}].course_name`}
                            value={
                              values?.academic_history?.[index]?.course_name
                            }
                            onChange={(e) =>
                              setFieldValue(
                                `academic_history[${index}].course_name`,
                                e.target.value
                              )
                            }
                            label="Course Name"
                            placeholder="Enter Course Name"
                            onBlur={handleBlur}
                          />
                        </div>
                        {/* Course Type */}
                        <div className="">
                          <ATMSelectValue
                            name={`academic_history[${index}].course_type`}
                            value={
                              values?.academic_history?.[index]?.course_type
                            }
                            onChange={(newValue) =>
                              setFieldValue(
                                `academic_history[${index}].course_type`,
                                newValue
                              )
                            }
                            onBlur={handleBlur}
                            label="Course Type"
                            placeholder="Select Course Type"
                            options={CourseOption}
                          />
                        </div>
                        {/* Course Tier */}
                        <div className="">
                          <ATMSelectValue
                            name={`academic_history[${index}].collge_school_tier`}
                            value={
                              values?.academic_history?.[index]
                                ?.collge_school_tier
                            }
                            onChange={(newValue) =>
                              setFieldValue(
                                `academic_history[${index}].collge_school_tier`,
                                newValue
                              )
                            }
                            onBlur={handleBlur}
                            label="College School Tier"
                            placeholder="Select College School Tier"
                            options={CollegeTearOption}
                          />
                        </div>
                        {/* ATMDATEPICKER */}
                        <div>
                          <ATMDatePicker
                            views={["year"]}
                            format="YYYY"
                            name={`academic_history[${index}].start_year`}
                            value={
                              values?.academic_history?.[index]?.start_year ||
                              null
                            }
                            onChange={(newValue) =>
                              setFieldValue(
                                `academic_history[${index}].start_year`,
                                newValue
                              )
                            }
                            label="Start Year"
                          />
                        </div>
                        <div>
                          <ATMDatePicker
                            views={["year"]}
                            format="YYYY"
                            name={`academic_history[${index}].end_year`}
                            value={
                              values?.academic_history?.[index]?.end_year ||
                              null
                            }
                            onChange={(newValue) =>
                              setFieldValue(
                                `academic_history[${index}].end_year`,
                                newValue
                              )
                            }
                            label="End Year"
                          />
                        </div>
                        <div className="mt-6">
                          <ATMCheckbox
                            value={
                              values?.academic_history?.[index]
                                ?.currently_pursuing
                            }
                            name={`academic_history[${index}].currently_pursuing`}
                            extraClasses="font-semibold"
                            checked={
                              values?.academic_history?.[index]
                                ?.currently_pursuing
                            }
                            onChange={(e) =>
                              setFieldValue(
                                `academic_history[${index}].currently_pursuing`,
                                e
                              )
                            }
                            label="Currently Pursuing"
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="flex justify-end my-4">
                  <p
                    className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                    onClick={() =>
                      push({
                        collge_school_name: "",
                        course_name: "",
                        end_year: "",
                        start_year: "",
                        course_type: "",
                        collge_school_tier: "",
                      })
                    }
                  >
                    <AiOutlinePlus size={18} color="#0064C4" className="mr-2" />
                    Add Academic History
                  </p>
                </div>
              </>
            )}
          />
        </div>
        <div className="border-l-[3px] border-primary-dark px-3 py-1  font font-medium text-[18px]  bg-white  text-primary-dark">
          Work History
        </div>
        <div className="mt-1">
          <FieldArray
            name="work_history"
            render={({ push, remove }) => (
              <>
                {values?.work_history?.map((doc: any, index: any) => {
                  return (
                    <div key={index}>
                      <div className="flex justify-end mt-3">
                        <MdDelete
                          color="#F70913"
                          size={30}
                          className="pl-1 cursor-pointer"
                          onClick={() => {
                            showConfirmationDialog({
                              title: "Heads Up",
                              text: "Are you sure want to Delete this Work History?",
                              icon: "question",
                              showCancelButton: true,
                              next: (result) => {
                                if (result.isConfirmed) {
                                  remove(index);
                                }
                              },
                            });
                          }}
                        />
                      </div>
                      <div className="grid xl:grid-cols-4 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4">
                        <div>
                          <ATMTextField
                            name={`work_history[${index}].company_name`}
                            value={values?.work_history?.[index]?.company_name}
                            onChange={(e) =>
                              setFieldValue(
                                `work_history[${index}].company_name`,
                                e.target.value
                              )
                            }
                            label="Company Name"
                            placeholder="Enter Company Name"
                            onBlur={handleBlur}
                          />
                        </div>
                        <div>
                          <ATMTextField
                            name={`work_history[${index}].job_title`}
                            value={values?.work_history?.[index]?.job_title}
                            onChange={(e) =>
                              setFieldValue(
                                `work_history[${index}].job_title`,
                                e.target.value
                              )
                            }
                            label="Job Title"
                            placeholder="Enter Job Title"
                            onBlur={handleBlur}
                          />
                        </div>

                        <div>
                          <ATMDatePicker
                            views={["year"]}
                            format="YYYY"
                            name={`work_history[${index}].start_year`}
                            value={
                              values?.work_history?.[index]?.start_year || null
                            }
                            onChange={(newValue) =>
                              setFieldValue(
                                `work_history[${index}].start_year`,
                                newValue
                              )
                            }
                            label="Start Year"
                          />
                        </div>
                        <div>
                          <ATMDatePicker
                            views={["year"]}
                            format="YYYY"
                            name={`work_history[${index}].end_year`}
                            value={
                              values?.work_history?.[index]?.end_year || null
                            }
                            onChange={(newValue) =>
                              setFieldValue(
                                `work_history[${index}].end_year`,
                                newValue
                              )
                            }
                            label="End Year"
                          />
                        </div>
                      </div>

                      <div className="mt-4">
                        <ATMTextArea
                          name={`work_history[${index}].job_description`}
                          value={values?.work_history?.[index]?.job_description}
                          onChange={(e) =>
                            setFieldValue(
                              `work_history[${index}].job_description`,
                              e
                            )
                          }
                          label="Job Description"
                          placeholder="Enter Job Description"
                          onBlur={handleBlur}
                        />
                      </div>

                      <div className="mt-4">
                        <ATMCheckbox
                          name={`work_history[${index}].currently_pursuing`}
                          value={
                            values?.work_history?.[index]?.currently_pursuing
                          }
                          extraClasses="font-semibold"
                          checked={
                            values?.work_history?.[index]?.currently_pursuing
                          }
                          onChange={(e) =>
                            setFieldValue(
                              `work_history[${index}].currently_pursuing`,
                              e
                            )
                          }
                          label="Currently Pursuing"
                        />
                      </div>
                    </div>
                  );
                })}
                <div className="flex justify-end my-4">
                  <p
                    className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                    onClick={() =>
                      push({
                        company_name: "",
                        job_description: "",
                        job_title: "",
                        end_year: "",
                        start_year: "",
                      })
                    }
                  >
                    <AiOutlinePlus size={18} color="#0064C4" className="mr-2" />
                    Add Work History
                  </p>
                </div>
              </>
            )}
          />
        </div>
      </div>

      <div className="flex justify-end">
        <div className="flex justify-end gap-2">
          <ATMLoadingButton
            className="px-6"
            isLoading={isSubmitting}
            type="submit"
          >
            Save
          </ATMLoadingButton>
          <ATMLoadingButton
            className="min-w-[150px]"
            isLoading={isSubmitting}
            type="submit"
            onClick={() => onRedirect()}
          >
            Save & Next
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default StudentForm;
